import get from 'lodash/get';

const getClickStreamLogData = (deliveryOptionsOffering, action) => {
    const { isStoreModalAtc = false } = action && action.payload;
    const deliveryOptionSelectedData =
        action.type === 'ITEM_UPDATE_REQUEST'
            ? get(action, 'payload', {})
            : get(action, 'payload.data[0]', {});
    const optionsSelected =
        action.type === 'ITEM_UPDATE_REQUEST'
            ? get(deliveryOptionSelectedData, 'params', {})
            : deliveryOptionSelectedData;
    const sdpuStoreInfo = get(action, 'payload.sdpuStoreInfo', {});
    const deliveryOption = get(action, 'payload.deliveryOption', {});
    const logType =
        action.type === 'ITEM_UPDATE_REQUEST'
            ? 'PDP_ATC_OFFERING_UPDATE_BAG_LOG'
            : 'PDP_ATC_OFFERING_ADD_TO_BAG_LOG';
    return {
        attributes: {
            name: logType,
            value: {
                offeringDeliveryOptions: {
                    shipToHome: {
                        availabilityStatus:
                            (deliveryOptionsOffering.shipToHome &&
                                deliveryOptionsOffering.shipToHome.availabilityStatus) ||
                            {},
                    },
                    bopus: {
                        availabilityStatus: isStoreModalAtc
                            ? `Added from Store Modal, Item Available in Store - ${sdpuStoreInfo.storeId}`
                            : (deliveryOptionsOffering.bopus &&
                                  deliveryOptionsOffering.bopus.locationIds.length &&
                                  deliveryOptionsOffering.bopus.locationIds[0]
                                      .availabilityStatus) ||
                              {},
                    },
                    shipToStore: {
                        availabilityStatus:
                            (deliveryOptionsOffering.shipToStore &&
                                deliveryOptionsOffering.shipToStore.locationIds.length &&
                                deliveryOptionsOffering.shipToStore.locationIds[0]
                                    .availabilityStatus) ||
                            {},
                    },
                },
                addToBagDeliveryOptions: {
                    optionSelected: {
                        skuId: optionsSelected.skuId,
                        type:
                            (optionsSelected.deliveryOption &&
                                optionsSelected.deliveryOption.type) ||
                            '',
                        selected:
                            (optionsSelected.deliveryOption &&
                                optionsSelected.deliveryOption.selected) ||
                            '',
                    },
                    shipToHomeOrStore: {
                        isChecked:
                            !isStoreModalAtc &&
                            deliveryOption.shipToHomeOrStore &&
                            deliveryOption.shipToHomeOrStore.isChecked,
                    },
                    sameDayPickUp: {
                        isChecked:
                            isStoreModalAtc ||
                            (deliveryOption.sameDayPickUp &&
                                deliveryOption.sameDayPickUp.isChecked),
                    },
                    sdpuStoreInfo: {
                        storeId: sdpuStoreInfo.storeId || {},
                    },
                },
            },
        },
    };
};

export default getClickStreamLogData;
